import { gql } from "gql";

export const SIGN_EXTERNAL_REGISTRATION = gql(/* GraphQL */ `
  mutation SignExternalRegistration($code: String!, $signatures: [String!]!) {
    signExternalRegistration(code: $code, signatures: $signatures) {
      ...SignRegistrationAfterExternalAction
    }
  }
`);
